export default {
      id: "menu__fuel-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__fuel",
      toString: function () {
        return this.url;
      }
    }